<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title col-sm-8">Schedule Email</h4>
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-3">
                            <label>Date</label>
                        </div>
                        <mat-form-field class="col-md-9 m-n no-padding">
                            <input matInput [(ngModel)]="date" name="date" [matDatepicker]="picker"
                                   [min]="currentTime" (focus)="picker.open()"
                                   (click)="picker.open()" placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-3">
                            <label>Time</label>
                        </div>
                        <div class="col-md-9 input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                            <input id="timepicker" class="form-control input-small" name="time" [ngModel]="time" required>
                            <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>
                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/email-scheduling-modal/email-scheduling-modal.component.html